export default __webpack_public_path__ + "static/media/1968.9a45b0c0.png";